

import React, { memo } from 'react';
import SingleValueAddon from '../../components/SingleValueAddon';











function BurnInCaptions({
  burnInCaptions,
  onChangeAddon,
  disabled,
  BURN_IN_CAPTIONS,
  editingMode,
  onCheckboxStateChange,
  showAboutInfo
}) {
  return (
    <SingleValueAddon
      name="BURN_IN_CAPTIONS"
      options={BURN_IN_CAPTIONS}
      addonValue={burnInCaptions}
      title="Captions - Burn in"
      subtitle="Spoken English videos only. Allow up to 48-72 hours."
      icon="burnin"
      onChangeAddon={onChangeAddon('BURN_IN_CAPTIONS')}
      disabled={disabled}
      editingMode={editingMode}
      onCheckboxStateChange={onCheckboxStateChange}
      showAboutInfo={showAboutInfo} />);


}

export default memo(BurnInCaptions);